import { fabric } from 'fabric'
import { v4 as uuidv4 } from 'uuid'

const MIME_MAP = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
}

const _maximizeFontTextBox = (
    text,
    targetWidth,
    targetHeight,
    fontFamily,
    fontWeight
) => {
    // NOTE: Setting to something arbitrarily large to ensure we can find a proper fontSize.
    let fontSize = 1000
    let textbox = new fabric.Textbox(text, {
        fontSize: fontSize,
        width: targetWidth,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
    })
    while (textbox.getBoundingRect().height > targetHeight) {
        textbox = new fabric.Textbox(text, {
            fontSize: fontSize--,
            width: targetWidth,
            fontFamily: fontFamily,
            fontWeight: fontWeight,
        })
    }
    return textbox
}

const _dataUrlToBlob = (dataUrl) => {
    const [metadata, base64] = dataUrl.split(',')
    let binaryStr = atob(base64)
    let bytes = new Uint8Array(binaryStr.length)
    for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i)
    }

    const contentType = metadata.replace('data:', '').replace(';base64', '')
    return new Blob([bytes], { type: contentType })
}

const _dataUrlToFile = (dataUrl) => {
    const blob = _dataUrlToBlob(dataUrl)
    const prefix = uuidv4().replaceAll('-', '')
    const ext = MIME_MAP[blob.type]
    return new File([blob], `${prefix}.${ext}`, { type: blob.type }) //TODO: determine extension based on mimetype
}

const _getImages = (canvas) => {
    return canvas
        .getObjects('image')
        .concat(canvas.getObjects('template-image'))
}

export const canvasUtils = {
    maxFontTextbox: (
        text,
        targetWidth,
        targetHeight,
        fontFamily,
        fontWeight
    ) => {
        return _maximizeFontTextBox(
            text,
            targetWidth,
            targetHeight,
            fontFamily,
            fontWeight
        )
    },

    findAllFonts: (canvas) => {
        let fonts = []
        let objects = canvas.objects
        for (let i = 0; i < objects.length; i++) {
            const obj = objects[i]
            if (
                obj.type === 'template-textbox' ||
                obj.type === 'textbox' ||
                obj.type === 'i-text' ||
                obj.type === 'text' ||
                obj.type === 'prompt-textbox'
            ) {
                fonts.push({ font: obj.fontFamily, weight: obj.fontWeight })
            }
        }
        return fonts
    },

    dataUrlToBlob: (dataUrl) => {
        return _dataUrlToBlob(dataUrl)
    },

    dataUrlToFile: (dataUrl) => {
        return _dataUrlToFile(dataUrl)
    },

    getImages: (canvas) => {
        return _getImages(canvas)
    },

    mapNewImages: (canvas) => {
        let imgData = {}
        _getImages(canvas).forEach((img) => {
            // Identify images added this session (blob: or data:)
            if (
                img.getSrc().startsWith('blob:') ||
                img.getSrc().startsWith('data:')
            ) {
                const file = canvasUtils.dataUrlToFile(img.getSrc())
                imgData[img.id] = file
            }
        })

        return imgData
    },
}
